import { createSelector } from 'reselect';
import * as DateRangePresets from 'foundations-components/transitional/components/Dates';
import { EQ } from 'framework-listing-lib/utils/filters';
import { getEqFilter } from 'web-interactives-dashboard-ui/utils/filters';
import { PROPERTIES_TO_CRM } from 'web-interactives-dashboard-ui/constants/properties';
import { FILTER_FEEDBACK_SURVEYS, FILTER_VARIANTS, FILTER_WEB_INTERACTIVES_AI_GENERATION } from 'web-interactives-dashboard-ui/constants/filters';
const getFilterState = state => state.filters;
export const getFilterStateWithDateDefaults = createSelector(getFilterState, filterState => {
  const filtersWithDefaults = Object.assign({}, filterState);
  if (!filtersWithDefaults.startDate) {
    const {
      presetId
    } = DateRangePresets.LAST_THIRTY_DAYS;
    const {
      startDate,
      endDate
    } = DateRangePresets.LAST_THIRTY_DAYS.getValue();
    filtersWithDefaults.dateType = presetId;
    filtersWithDefaults.startDate = startDate;
    filtersWithDefaults.endDate = endDate;
  }
  return filtersWithDefaults;
});
const createFilterStateSelector = key => {
  return createSelector(getFilterState, filters => filters[key]);
};

// sidebar filter
export const getFilterByState = createFilterStateSelector('state');
export const getIsArchivedFilter = createSelector([getFilterByState], ctaState => ctaState === 'archived');

// filter bar
export const getSearchQuery = createFilterStateSelector('searchQuery');
export const getSelectedCampaign = createFilterStateSelector('campaignId');
export const getContainerTypeFilter = createFilterStateSelector('containerType');

// other filters
export const getCurrentDateRangeWithDefaults = createSelector(getFilterStateWithDateDefaults, filterState => ({
  startDate: filterState.startDate,
  endDate: filterState.endDate,
  presetId: filterState.dateType
}));
const INITIAL_FILTER_STATE = {
  sort: {
    property: PROPERTIES_TO_CRM.UPDATED_AT,
    order: 'DESC'
  },
  filterGroups: [{
    filters: [EQ(PROPERTIES_TO_CRM.IS_ARCHIVED, false)]
  }]
};
export const getInitialFilterState = createSelector([getFilterByState, getSearchQuery], (filterState, searchQuery) => {
  let result = INITIAL_FILTER_STATE;
  const isArchivedSearch = filterState === 'archived';
  if (filterState !== 'all' && !isArchivedSearch) {
    result = Object.assign({}, result, {
      filterGroups: [{
        filters: [EQ(PROPERTIES_TO_CRM.STATE, filterState.toUpperCase()), EQ(PROPERTIES_TO_CRM.IS_ARCHIVED, false)]
      }]
    });
  }
  if (searchQuery) {
    result = Object.assign({}, result, {
      query: searchQuery
    });
  }
  if (isArchivedSearch) {
    result = Object.assign({}, result, {
      filterGroups: [{
        filters: [EQ(PROPERTIES_TO_CRM.IS_ARCHIVED, true)]
      }]
    });
  }
  return result;
});
export const getHiddenFilter = createSelector([getContainerTypeFilter], containerType => {
  const containerTypeFilter = getEqFilter({
    property: PROPERTIES_TO_CRM.CONTAINER_TYPE,
    value: containerType
  });
  return {
    filterGroups: [{
      filters: containerTypeFilter ? [FILTER_WEB_INTERACTIVES_AI_GENERATION, FILTER_FEEDBACK_SURVEYS, FILTER_VARIANTS, containerTypeFilter] : [FILTER_WEB_INTERACTIVES_AI_GENERATION, FILTER_FEEDBACK_SURVEYS, FILTER_VARIANTS]
    }]
  };
});